<template>
  <b-modal
    id="modal-client"
    no-close-on-backdrop
    centered
    hide-footer
    hide-header
    body-class="modal-addClient"
    content-class="modal-addClient"
  >
    <template #default>
      <b-container fluid>
        <b-row class="justify-content-center mt-2">
          <b-col cols="auto">
            <b-icon
              v-if="isConfirm"
              icon="check-circle-fill"
              style="color: #4dae89; width: 50px; height: 50px"
            ></b-icon>
            <b-icon
              v-else
              icon="x-circle-fill"
              style="color: #d85a4a; width: 50px; height: 50px"
            ></b-icon>
          </b-col>
        </b-row>
        <b-row class="justify-content-center mt-3">
          <b-col cols="6">
            <p v-if="isConfirm" class="text1-modal addClient">
              Tem certeza que deseja adicionar?
            </p>
            <p v-else class="text1-modal cancel">
              Tem certeza que deseja cancelar?
            </p>
          </b-col>
        </b-row>
        <b-row class="justify-content-center mb-5 mt-3">
          <b-col cols="6">
            <p v-if="isConfirm" class="text2-modal">
              Após a confirmação você <br />
              poderá alterar esse item
            </p>
            <p v-else class="text2-modal">As alterações não serão salvas</p>
          </b-col>
        </b-row>
        <b-row class="justify-content-center mb-3">
          <b-col cols="auto">
            <button
              class="button-modal-addClient btn-one"
              @click="$bvModal.hide('modal-client')"
            >
              VOLTAR
            </button>
          </b-col>
        </b-row>
        <b-row class="justify-content-center mb-2">
          <b-col cols="auto">
            <button
              v-if="isConfirm"
              class="button-modal-addClient btn-two addClient"
              type="button"
              @click="responseModal(true)"
            >
              CONFIRMAR
            </button>
            <button
              v-else
              class="button-modal-addClient btn-two cancel"
              type="button"
              @click="responseModal(false)"
            >
              CANCELAR
            </button>
          </b-col>
        </b-row>
      </b-container>
    </template>
  </b-modal>
</template>

<script>
export default {
  methods: {
    responseModal(isConfirm) {
      this.$emit('responseModalClient', isConfirm);
    },
  },
  props: {
    isConfirm: {
      type: Boolean,
      default: true,
    },
  },
};
</script>

<style>
.modal-addClient {
  background-color: #e8e8e8;
  padding: 8px;
  border-radius: 12px;
  border: none;
}

.text1-modal,
.text2-modal,
.button-modal-addClient {
  font-family: 'Inter', sans-serif;
  font-style: normal;
}

.text1-modal,
.text2-modal {
  text-align: center;
}

.text1-modal {
  font-size: 24px;
  font-weight: 900;
}

.text1-modal.addClient {
  color: #4dae89;
}

.text1-modal.cancel {
  color: #d85a4a;
}

.text2-modal {
  font-weight: 300;
  font-size: 16px;
  color: black;
}

.button-modal-addClient {
  min-width: fit-content;
  width: 196px;
  height: 28px;
  font-size: 12px;
  line-height: 12px;
  letter-spacing: 0.35em;
  font-weight: 700;
  border-radius: 13px;
}

.button-modal-addClient:focus {
  outline: none;
}

.btn-one {
  color: #272727;
  border: 1px solid #272727;
  background-color: transparent;
}

.btn-two.addClient,
.btn-two.cancel {
  color: white;
  border: none;
}

.btn-two.addClient {
  background-color: #4dae89;
}

.btn-two.cancel {
  background-color: #d85a4a;
}
</style>
